import styled from 'styled-components';
import { colors, Grid, Row } from '@dexma/ui-components';
import Branding from 'domain/entity/branding';

type FeaturePresetRow = {
    $isSelected: boolean;
    $branding?: Branding;
    onClick?: () => void;
};

export const StyledPanelMain = styled(Grid)`
    margin-top: 16px;
    padding: 0 30px;
    overflow: auto;

    .secondaryTitle {
        color: ${colors.gray500};
        font-size: 16px;
    }

    .mainTitle {
        color: ${colors.gray700};
        font-size: 20px;
        margin-bottom: 24px;
    }
    .mainTitleWidget {
        color: ${colors.gray700};
        font-size: 20px;
        margin-bottom: 24px;
        margin-top: 24px;
    }
`;

const getRightActiveColor = (props: FeaturePresetRow) => {
    if (props.$isSelected && props.$branding) {
        return props.$branding.primaryColor;
    }
    if (props.$isSelected) {
        return colors.teal600;
    }
    return colors.gray500;
};

export const StyledFeaturePreset = styled(Row)<FeaturePresetRow>`
    color: ${(props) => getRightActiveColor(props)};
    padding: 2px 0px;
    margin: 8px 0px;
    cursor: pointer;
    font-weight: 500;

    span {
        margin-left: 2px;
    }

    :hover {
        color: ${(props) => (props.$isSelected && props.$branding ? props.$branding.primaryColor : colors.gray800)};
        background-color: ${colors.gray50};
    }
`;
